import { createContext, useContext, useState } from 'react'
import { theme as antdTheme } from 'antd'
import { DARK_MODE, LIGHT_MODE } from '../constants'

const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(DARK_MODE)
  const { darkAlgorithm, defaultAlgorithm } = antdTheme
  const algorithm = mode === DARK_MODE ? darkAlgorithm : defaultAlgorithm

  return (
    <ThemeContext.Provider value={{ mode, setMode, algorithm }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useThemeContext = () => useContext(ThemeContext)
